export const reports = [
  {
    id: "1",
    title: "서울 강남구 역삼동 아파트 물건분석 리포트",
    type: "물건분석",
    description: "2026년 6월 입찰 예정인 서울 강남구 역삼동 소재 아파트에 대한 종합 물건분석 리포트입니다. 권리분석, 시세 분석, 예상 수익률까지 한 번에 확인하세요.",
    price: 99000,
    thumbnail: "https://img.echotwin.kr/kangstudy/96862d72f0e7a652.jpg",
    createdAt: "2026-05-25",
    sales: 128,
    pages: 24,
    author: "강현우",
    tags: ["강남", "아파트", "고수익"],
    valueTag: "예상 시세차익 8천만원+",
    achievement: "실제 낙찰 성공률 87%",
  },
  {
    id: "2",
    title: "경기 성남시 분당구 상가주택 물건분석 리포트",
    type: "물건분석",
    description: "분당구 야탑동 소재 상가주택 경매 물건에 대한 상세 분석 리포트입니다. 임차인 현황, 명도 리스크, 투자 가치 평가가 포함되어 있습니다.",
    price: 149000,
    thumbnail: "https://img.echotwin.kr/kangstudy/cd1bc3e4995fc9e8.jpg",
    createdAt: "2026-05-24",
    sales: 84,
    pages: 32,
    author: "강현우",
    tags: ["분당", "상가주택", "임차인"],
    valueTag: "임차인 명도 리스크 발견",
    achievement: "월 예상 임대수익 250만원",
  },
  {
    id: "3",
    title: "인천 서구 청라동 오피스텔 물건분석 리포트",
    type: "물건분석",
    description: "청라국제도시 내 오피스텔 경매 물건의 투자 가치를 분석한 리포트입니다. 주변 임대 시세, 공실률, 향후 개발 계획까지 담았습니다.",
    price: 79000,
    thumbnail: "https://img.echotwin.kr/kangstudy/5266db8e295d0879.jpg",
    createdAt: "2026-05-23",
    sales: 56,
    pages: 18,
    author: "강현우",
    tags: ["청라", "오피스텔", "임대수익"],
    valueTag: "월 임대수익 120만원 기대",
    achievement: "공실률 2% 미만 지역",
  },
  {
    id: "4",
    title: "2026년 2분기 서울 지역 경매시장 분석 리포트",
    type: "지역분석",
    description: "2026년 2분기 서울 25개구 경매시장 동향을 종합 분석한 리포트입니다. 지역별 낙찰가율, 평균 응찰자 수, 유찰 추이 데이터를 제공합니다.",
    price: 199000,
    thumbnail: "https://img.echotwin.kr/kangstudy/a786008922668a6e.jpg",
    createdAt: "2026-05-20",
    sales: 215,
    pages: 46,
    author: "강스터디 연구소",
    tags: ["서울", "시장분석", "2분기"],
    valueTag: "투자 유망 지역 TOP5 선정",
    achievement: "215명이 선택한 베스트셀러",
  },
  {
    id: "5",
    title: "경기 남부권 경매시장 핵심 분석 2026",
    type: "지역분석",
    description: "수원, 성남, 용인, 화성 등 경기 남부권 주요 도시의 경매시장을 심층 분석했습니다. 투자 유망 지역 5곳을 선정하여 상세 분석을 제공합니다.",
    price: 159000,
    thumbnail: "https://img.echotwin.kr/kangstudy/8f69b076321d471b.jpg",
    createdAt: "2026-05-18",
    sales: 167,
    pages: 38,
    author: "강스터디 연구소",
    tags: ["경기남부", "수원", "용인"],
    valueTag: "저평가 우량 물건 12건 발굴",
    achievement: "낙찰가율 78% 최적 구간 분석",
  },
  {
    id: "6",
    title: "경매 초보자를 위한 필수 체크리스트",
    type: "체크리스트",
    description: "경매 입문자가 반드시 확인해야 할 50가지 체크포인트를 정리했습니다. 입찰 전 준비사항부터 낙찰 후 명도까지 단계별로 안내합니다.",
    price: 49000,
    thumbnail: "https://img.echotwin.kr/kangstudy/6600739090b97222.jpg",
    createdAt: "2026-05-15",
    sales: 543,
    pages: 14,
    author: "강현우",
    tags: ["초보자", "필수", "체크리스트"],
    valueTag: "50가지 실전 체크포인트",
    achievement: "543명 입문자가 선택",
  },
  {
    id: "7",
    title: "권리분석 실전 체크리스트 100",
    type: "체크리스트",
    description: "등기부등본, 건축물대장, 토지대장 등 권리분석에 필요한 모든 서류의 확인 포인트를 100가지로 정리한 실전 가이드입니다.",
    price: 69000,
    thumbnail: "https://img.echotwin.kr/kangstudy/89f52e551789ef92.jpg",
    createdAt: "2026-05-12",
    sales: 398,
    pages: 22,
    author: "강현우",
    tags: ["권리분석", "등기부등본", "실전"],
    valueTag: "특수권리·하자 발견 가이드",
    achievement: "체크리스트 평점 ★4.8",
  },
  {
    id: "8",
    title: "대구 수성구 범어동 아파트 물건분석 리포트",
    type: "물건분석",
    description: "대구 수성구 범어동 대단지 아파트 경매 물건 분석 리포트입니다. 학군, 교통, 생활 인프라까지 종합적으로 평가했습니다.",
    price: 99000,
    thumbnail: "https://img.echotwin.kr/kangstudy/69a7773bd9b5bf42.jpg",
    createdAt: "2026-05-10",
    sales: 71,
    pages: 26,
    author: "강현우",
    tags: ["대구", "수성구", "학군"],
    valueTag: "학군 프리미엄 시세차익 기대",
    achievement: "명문 학군 · 전세가율 72%",
  },
  {
    id: "9",
    title: "명도실무 완벽 가이드 리포트",
    type: "체크리스트",
    description: "명도소송부터 강제집행까지, 실제 사례를 바탕으로 작성한 명도실무 완벽 가이드입니다. 임차인 유형별 대응 전략을 상세히 담았습니다.",
    price: 89000,
    thumbnail: "https://img.echotwin.kr/kangstudy/212fd27abe092d1b.jpg",
    createdAt: "2026-05-08",
    sales: 276,
    pages: 30,
    author: "강현우",
    tags: ["명도", "임차인", "소송"],
    valueTag: "명도 리스크 90% 회피 성공",
    achievement: "임차인 유형별 맞춤 전략",
  },
  {
    id: "free-1",
    title: "[무료] 경매 투자 입문 가이드",
    type: "무료",
    description: "경매 투자를 처음 시작하는 분들을 위한 무료 입문 가이드입니다. 경매 기본 개념, 용어 정리, 투자 흐름을 한눈에 이해할 수 있습니다.",
    price: 0,
    thumbnail: "https://img.echotwin.kr/kangstudy/64922c98bc6442a4.jpg",
    createdAt: "2026-06-01",
    sales: 1247,
    pages: 10,
    author: "강현우",
    tags: ["입문", "무료", "기초"],
    valueTag: "12,000명이 다운로드한 인기 가이드",
    achievement: "경매 입문자 필독서",
  },
  {
    id: "free-2",
    title: "[무료] 2026 경매시장 전망 요약",
    type: "무료",
    description: "2026년 하반기 경매시장 전망을 간략하게 요약한 무료 리포트입니다. 금리, 부동산 정책, 지역별 전망을 핵심만 정리했습니다.",
    price: 0,
    thumbnail: "https://img.echotwin.kr/kangstudy/529e4e293f1ec924.jpg",
    createdAt: "2026-06-05",
    sales: 892,
    pages: 8,
    author: "강스터디 연구소",
    tags: ["시장전망", "무료", "2026"],
    valueTag: "하반기 투자 전략 미리보기",
    achievement: "금리·정책 변수 완벽 정리",
  },
];

export const reportTypes = ["전체", "물건분석", "지역분석", "체크리스트", "무료"];